import { useEffect, useState } from 'react';
import { UseFetchStatesType } from '../lib/types/types';
import GetRecords from '../lib/api/GetRecords';
import { removeDataKeys, removeNullDeep } from '../utils/helper';
import { APIS } from '../lib/constants/apis';
import { get } from 'lodash';
import { getLocalstorageToken } from '../context/AuthHelper';

function useFetchApplicationsForNachrichten(): UseFetchStatesType {
	const [loading, setLoading] = useState<boolean>(false);
	const [data, setData] = useState<any[]>([]);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		// Fetch data
		const fetchData = async () => {
			try {
				const filter = {
					AN_Organisation: get(getLocalstorageToken(), 'organisationId'),
					Antragsstatus_Antragsstatus: { $ne: 'inBearbeitung' },
				};
				const res = await GetRecords(APIS.Zuwendungsantrag, [], filter);
				const result: any[] = removeNullDeep(removeDataKeys(get(res, 'data', [])));
				setData(result);
			} catch (err: any) {
				setError(err.message);
			} finally {
				setLoading(false);
			}
		};

		fetchData();
	}, []);

	return { loading, data, error };
}
export { useFetchApplicationsForNachrichten };
